export const CONTAINER_ID_FOR_STANDALONE_MODE = 'product-provided-container';
